<template>
	<div class="flex items-center">
		<input
			type="checkbox"
			:id="inputId"
			v-model="val"
			class="mt-0.5 h-5 w-5 border-gray-300 hover:border-gray-500 rounded cursor-pointer"
			:class="
				disabled
					? 'text-gray-400 focus:ring-gray-400'
					: 'text-orange-500 focus:ring-orange-500'
			"
			:disabled="disabled"
		/>
		<div class="">
			<label
				:for="inputId"
				class="pl-3 block font-medium text-gray-700 cursor-pointer"
			>
				<slot>{{ __(label) }}</slot>
				<ui-tooltip
					v-if="tooltipText"
					class="text-green-400 whitespace-normal"
					:icon-stroke-width="2"
					icon-class="ml-1 w-4 h-4"
					:text="__(tooltipText)"
				/>
			</label>
			<!-- <span class="text-gray-500" v-if="!required">optional</span> -->
			<div class="text-red-500" v-if="markInvalid">{{ validationMessage }}</div>
		</div>
	</div>
</template>

<script>
import UiInputGroup from "./InputGroup.vue";
export default {
	mixins: [UiInputGroup],
	props: {
		type: {
			type: String,
			default: "checkbox",
		},
		label: {
			type: String,
			required: false,
		},
		tooltipText: {
			type: String,
			default: "",
		},
		disabled: {
			type: Boolean,
			default: false,
			required: false,
		},
	},
	data() {
		return {
			val: this.value,
		};
	},
	created() {
		if (this.val == null) {
			this.val = false;
		}
	},
};
</script>
